const styles = getComputedStyle(document.documentElement);

export const getTailwindProperty = (property: string): string => styles.getPropertyValue(property);
